import { ExtraCategorizationVO } from "../../domain/valueObjects/ExtraCategorizationVO";
import { VehicleType } from "../../domain/VehicleType";
import { ExtraCategoryFormFields } from "../types/ExtraCategoryFormTypes";

export const mapExtraCategorizationToForm = (
  categorization: ExtraCategorizationVO
): ExtraCategoryFormFields => ({
  category: categorization.category,
  vehicleType: categorization.vehicleType?.code,
  requestLicensePlate: categorization.requestLicensePlate,
});

export const mapExtraCategoryFormToDomain = ({
  category,
  vehicleType,
  requestLicensePlate,
}: ExtraCategoryFormFields): ExtraCategorizationVO =>
  ExtraCategorizationVO.of({
    category,
    vehicleType: VehicleType.tryOf(vehicleType),
    requestLicensePlate,
  });

/** Form values of a new extra: *No category*. */
export const defaultExtraCategoryFormFields = (): ExtraCategoryFormFields =>
  mapExtraCategorizationToForm(ExtraCategorizationVO.none());
